import type { ReactNode } from 'react';

/**
 * Community categories — ported from the OG WINR `CATEGORIES` (js/data.js:68).
 * Counts are NOT stored here; they're computed from the live community list
 * (see ExplorePage). `id` matches the `communities.category` value used to filter.
 */
export interface Category {
  id: string;
  name: string;
  icon: ReactNode;
}

const svg = (children: ReactNode) => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth={2}>
    {children}
  </svg>
);

export const CATEGORIES: Category[] = [
  { id: 'business', name: 'Business', icon: svg(<><rect x="2" y="7" width="20" height="14" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></>) },
  { id: 'trading', name: 'Trading', icon: svg(<><polyline points="22 7 13.5 15.5 8.5 10.5 2 17" /><polyline points="16 7 22 7 22 13" /></>) },
  { id: 'agency', name: 'Agency', icon: svg(<><polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" /></>) },
  { id: 'content', name: 'Content', icon: svg(<><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33 2.78 2.78 0 0 0 1.94 2c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.33 29 29 0 0 0-.46-5.33z" /><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" /></>) },
  { id: 'fitness', name: 'Fitness', icon: svg(<polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />) },
  { id: 'crypto', name: 'Crypto', icon: svg(<><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></>) },
  { id: 'ai-tech', name: 'AI & Tech', icon: svg(<><rect x="3" y="11" width="18" height="10" rx="2" /><circle cx="12" cy="5" r="2" /><path d="M12 7v4" /><line x1="8" y1="16" x2="8" y2="16" /><line x1="16" y1="16" x2="16" y2="16" /></>) },
  { id: 'mindset', name: 'Mindset', icon: svg(<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />) },
];
